import React, { FC, memo, ReactNode, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'app/config/storeConfig/hooks';
import { StepperModal, stepperModalActions } from 'features/StepperModal';
import { TableFilterContextProvider, useTableFilterContext } from 'features/TableFilter';
import { getZoneCreateOpenedState, getZoneCreateSteps } from '../model/selectors';
import { createZoneModalActions } from '../model/slice/createZoneModalSlice';
import { ZoneBasicsStep } from './steps/ZoneBasicsStep';
import { SelectObjectsStep } from './steps/SelectObjectsStep';
import { SelectUsersStep } from './steps/SelectUsersStep';

export const CreateZoneModal: FC = memo(() => {
  const dispatch = useAppDispatch();

  const isOpened = useAppSelector(getZoneCreateOpenedState);
  const steps = useAppSelector(getZoneCreateSteps);

  const { clearAllFilters } = useTableFilterContext();

  const closeModal = useCallback(() => {
    dispatch(createZoneModalActions.resetModalState());
    dispatch(stepperModalActions.changeActiveStepIndex(0));
    clearAllFilters();
  }, [dispatch, clearAllFilters]);

  const stepsContent: ReactNode[] = [
    <ZoneBasicsStep key="1" />,
    <TableFilterContextProvider key="2">
      <SelectObjectsStep />
    </TableFilterContextProvider>,
    <SelectUsersStep onClose={closeModal} key="3" />,
  ];

  return <StepperModal isOpened={isOpened} onClose={closeModal} steps={steps} stepsContent={stepsContent} width={1129} />;
});
